import { Injectable } from '@angular/core';
import { CatalogSearchResultModel } from '@libs/shop/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductBundleRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public getProductBundles(): Observable<CatalogSearchResultModel> {
    return this.connector.connect('shop', 'productBundles');
  }
}
